import React from 'react';
import classNames from 'classnames';
import { Avatar, ButtonContainer, ButtonInfo } from './';
import styles from './BotMessageWrapper.module.css';
import sharedStyles from '../shared.module.css';

import { AmpFlagSet } from '../amplitude';

type BotMessageWrapperArgs = {
    text: string;
    buttons?: ButtonInfo[];
    featureFlags: AmpFlagSet;
};

export const BotMessageWrapper: React.FC<BotMessageWrapperArgs> = ({
    text,
    buttons,
    featureFlags,
}: BotMessageWrapperArgs) => {
    return (
        <div
            className={classNames(
                sharedStyles.botMessageContainer,
                styles.messageWrapperBubbleExtra
            )}
        >
            <div className={sharedStyles.botMessageAvatar}>
                <Avatar />
            </div>
            <div
                className={classNames(
                    sharedStyles.botMessageBubble,
                    styles.messageWrapperBubbleContainer
                )}
            >
                <p className={styles.messageWrapperReturnDescription}>{text}</p>
                {buttons && (
                    <ButtonContainer
                        buttons={buttons}
                        featureFlags={featureFlags}
                    />
                )}
            </div>
        </div>
    );
};

export default BotMessageWrapper;
